import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream-100 font-sans text-navy-900 selection:bg-gold-500/30" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyItFailed data-id="element-4" />
      <Mechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <OfferBlock data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}